import { Panel } from "../../components/Panel/Panel.jsx";
import { ProgressMeter } from "../../components/ProgressMeter/ProgressMeter.jsx";
import "./AnalysisOverviewMeterCard.css";

export function AnalysisOverviewMeterCard({
  label,
  valueLabel,
  levels = []
}) {
  return (
    <Panel className="analysis-overview-meter-card" header={label} headerEnd={valueLabel} padded>
      <div class="analysis-overview-meter-card-body">
        <ProgressMeter
          levels={levels}
        />
        <div class="analysis-overview-meter-card-summary">
          {[...levels]
            .reverse()
            .filter((level) => level.label)
            .map((level) => (
              <span key={level.key} class="analysis-overview-meter-card-summary-item">
                <span
                  class={[
                    "analysis-overview-meter-card-swatch",
                    `tone-${level.tone ?? "good"}`,
                    level.emphasis ? `emphasis-${level.emphasis}` : ""
                  ].filter(Boolean).join(" ")}
                />
                <span>{level.label}</span>
              </span>
            ))}
        </div>
      </div>
    </Panel>
  );
}
